/**
* 头部菜单
*/
<template>
  <div>
    <div
      style="display: flex;align-items: center;background: white;justify-content: space-between;background: #1F2227;">
      <el-button v-if="isshow" class="buttonimg">
        <i :class="collapsed ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="toggle(collapsed)"
          style="font-size: 20px;"></i>
      </el-button>
      <div v-else class="title">
        <div @click="goback"><i class="el-icon-back" style="font-weight: bold;margin-right: 10px;"></i>返回</div>
      </div>
      <div v-if="isshowMenu" class="newbtn">
        <!-- :class="theme" -->
        <span v-if="haveThis(107)" @click="setNavStatus(0)" :class="{ 'span': $store.state.nav_status == 0 }">商城</span>
        <span v-if="haveThis(1000)" @click="setNavStatus(1)"
          :class="{ 'span': $store.state.nav_status == 1 }">打印发货</span>
        <!-- <span @click="setNavStatus(2)" :class="{'span':$store.state.nav_status==2}">数据</span>
        <span @click="setNavStatus(3)" :class="{'span':$store.state.nav_status==3}">营销</span>
        <p>|</p> -->
        <span v-if="haveThis(2200)" @click="setNavStatus(6)" :class="{ 'span': $store.state.nav_status == 6 }"><i
            class="el-icon-s-data" style="margin-right: 4px;"></i>数据</span>
        <span v-if="haveThis(1500)" @click="setNavStatus(5)" :class="{ 'span': $store.state.nav_status == 5 }"><i
            class="el-icon-menu" style="margin-right: 4px;"></i>仓库</span>
        <span v-if="haveThis(1025)" @click="setNavStatus(4)" :class="{ 'span': $store.state.nav_status == 4 }"><i
            class="el-icon-menu" style="margin-right: 4px;"></i>应用</span>
        <!-- <span @click="setNavStatus(5)" :class="{'span':$store.state.nav_status==5}">物流配置</span> -->
      </div>
      <div style="display: flex;align-items: center;justify-content: flex-end;">
        <template v-if="isshowMenu">
          <el-button @click="goAdd" v-havePermission="[58, 'inline-block']" type="primary" size="small" v-if="is_open_product_market == 1">货源市场</el-button>
        </template>
        <el-tooltip effect="light" content="用户使用店铺链接" placement="bottom">
          <el-button
            v-if="$store.state.shop_data && $store.state.shop_data.shopCate.type != 'offline' && $store.state.shop_data.status == 1"
            @click="shareLink" type="text" size="small" style="color: white;">分享链接</el-button>
        </el-tooltip>
        <el-tooltip effect="light" content="开全屏" placement="bottom">
          <i @click="openFullScreen" class="el-icon-full-screen iclass"></i>
        </el-tooltip>
        <el-tooltip effect="light" content="消息队列" placement="bottom" style="margin-right: 20px;">
          <el-badge :value="messageCount" :max="99" v-if="messageCount > 0">
            <i @click="goMessage()" class="el-icon-message-solid iclass"></i>
          </el-badge>
          <i v-else @click="goMessage()" class="el-icon-message-solid iclass"></i>
        </el-tooltip>
        <el-menu class="el-menu-demo" mode="horizontal" background-color="#1F2227" text-color="white"
          active-text-color="white">
          <el-submenu index="2" class="submenu">
            <template slot="title"><el-avatar size="small" :src="user.avatar"
                style="margin-right: 6px;"></el-avatar></template>
            <template slot="title">{{ user.account }}</template>
            <el-menu-item v-if="isshowMenu" @click="gochooseStore" index="2-1">切换店铺</el-menu-item>
            <el-menu-item v-if="isshowMenu" @click="goupdatePwd" index="2-2">修改密码</el-menu-item>
            <el-menu-item v-if="isshowMenu && $store.state.shop_status == 1" @click="gouserCenter"
              index="2-3">个人中心</el-menu-item>
            <el-menu-item v-if="isshowMenu" @click="clear" index="2-5">清除缓存</el-menu-item>
            <el-menu-item @click="exit()" index="2-4">退出登录</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </div>
    <el-drawer title="消息队列" :visible.sync="drawerVisible" direction="rtl" size="30%" @close="drawerVisible = false">
      <div style="display: flex; justify-content: flex-start; margin: 0 10px 10px;">
        <el-button size="mini" type="primary" @click="markAllAsRead" style="margin-right: 8px;">全部已读</el-button>
        <el-button size="mini" type="danger" @click="deleteAllMessages">全部删除</el-button>
      </div>
      <div v-if="messageList.length === 0" class="message-list-empty">暂无消息</div>
      <div v-else class="message-list">
        <div v-for="msg in messageList" @click="showMessageDetail(msg)"
          style="margin-bottom: 12px; cursor: pointer; background: #fafbfc; border-radius: 4px; padding: 10px; position: relative;">
          <div style="position: absolute; top: 6px; right: 8px; z-index: 2;">
            <el-button type="text" size="mini" @click.stop="deleteSingleMessage(msg)">
              <i class="el-icon-delete"></i>
            </el-button>
          </div>
          <div style="display: flex; align-items: center;">
            <i v-if="msg.type == 0" class="el-icon-success"
              style="color: #67C23A; font-size: 18px; margin-right: 6px;"></i>
            <i v-else class="el-icon-error" style="color: #F56C6C; font-size: 18px; margin-right: 6px;"></i>
            <span>{{ msg.title }}</span>
          </div>
          <div style="margin-top: 6px;margin-bottom: 20px; font-size: 12px; color: #aaa;">
            {{ msg.content }}
          </div>
          <div style="position: absolute; left: 10px; bottom: 6px; font-size: 12px; color: #aaa;">
            {{ msg.add_time }}
          </div>
          <div style="position: absolute; right: 10px; bottom: 6px; font-size: 12px; color: #aaa;">
            {{ msg.is_read == 1 ? '已读' : '未读' }}
          </div>
        </div>
      </div>
    </el-drawer>

    <!-- 新增弹窗 -->
    <el-dialog :title="currentMessage && currentMessage.title ? currentMessage.title : '消息详情'"
      :visible.sync="dialogVisible" width="400px" @close="dialogVisible = false">
      <div v-if="currentMessage" style="padding: 10px 0; text-align: left; position: relative; min-height: 80px;">
        <div style="margin-bottom: 8px; text-indent: 2em;"><strong>内容：</strong>{{ currentMessage.content }}</div>
        <div style="margin-bottom: 16px; text-indent: 2em;"><strong>时间：</strong>{{ currentMessage.add_time }}</div>
        <div v-if="!currentMessage.type == 0 && currentMessage.data" style="position: absolute; right: 0; bottom: 0;">
          <el-button type="primary" size="small" @click="handleExportExcel">下载错误数据</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
* 此处为 currentMessage.type 判断（data）
* data 0 普通文本（成功，其他失败），无data
* data 1 import，data为表格数据Json
* data 2 import，data为url
*/
import {
  setCookie,
  getCookie,
  delCookie
} from '../utils/util'
import { mapState, mapMutations } from 'vuex'
import * as XLSX from 'xlsx/xlsx.mjs';
export default {
  name: 'navcon',
  props: {
    isshow: {
      type: Boolean,
      default: true
    },
    isshowMenu: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      collapsed: true,
      user: {},
      showShare: false,
      drawerVisible: false,
      messageList: [],
      dialogVisible: false,
      currentMessage: null,
      is_open_product_market: 0,
    }
  },
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata_shop'))
    // 监听 storage 事件，跨页面同步
    window.addEventListener('storage', this.syncMessageCount);
    this.getMessage();
    this.is_open_product_market = localStorage.getItem('is_open_product_market') || 0;
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.syncMessageCount)
  },
  computed: {
    ...mapState(['messageCount'])
  },
  methods: {
    ...mapMutations(['setMessageCount']),
    syncMessageCount(e) {
      if (e.key === 'shop_message_count') {
        this.setMessageCount(Number(e.newValue || 0))
      }
    },
    clear() {
      this.$get(this.$api.permissionDalete).then(res => {
        if (res.status == 200) {
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }
      }).catch(error => {
        this.$message({
          message: error.message,
          type: 'error'
        });
      });
    },
    // 获取权限列表
    getPermissionList() {
      this.$get(this.$api.permissionList).then(res => {
        if (res.status == 200) {
          localStorage.setItem('menuList', JSON.stringify(res.data))
          this.getRuleIds()
        }
      })
    },
    // 获取当前帐号的权限ids
    getRuleIds() {
      this.$get(this.$api.ruleIds).then(res => {
        if (res.status == 200) {
          localStorage.setItem('ruleIds', JSON.stringify(res.data))
          //清理缓存后 刷新页面
          location.reload();
        }
      })
    },
    goback() {
      this.$router.go(-1)
    },
    haveThis(id) {
      let list = JSON.parse(localStorage.getItem('menuList'))
      return list.some(item => { return item.rule_id === id })
    },
    goAdd() {
      this.$router.push({
        path: '/sourceMarket'
      });
    },
    setNavStatus(idx) {

      this.$store.commit('saveNavStatus', idx)
      if (idx == 0) {
        let result = JSON.parse(localStorage.getItem('menuList')).filter(item => {
          return item.rule_id == 107
        })
        let path = result[0].child[0]
        if (path.type == 'menu') {
          path = result[0].child[0].path
        } else {
          path = result[0].child[0].child[0].path
        }
        this.$router.push({
          path: path
        })
      } else if (idx == 1) {
        let result = JSON.parse(localStorage.getItem('menuList')).filter(item => {
          return item.rule_id == 1000
        })
        let path = result[0].child[0]
        if (path.type == 'menu') {
          path = result[0].child[0].path
        } else {
          path = result[0].child[0].child[0].path
        }
        this.$router.push({
          path: path
        })
      } else if (idx == 4) {
        let result = JSON.parse(localStorage.getItem('menuList')).filter(item => {
          return item.rule_id == 1025
        })
        let path = result[0].child[0]
        if (path.type == 'menu') {
          path = result[0].child[0].path
        } else {
          path = result[0].child[0].child[0].path
        }
        this.$router.push({
          path: path
        })
      } else if (idx == 5) {
        let result = JSON.parse(localStorage.getItem('menuList')).filter(item => {
          return item.rule_id == 1500
        })
        let path = result[0].child[0]
        if (path.type == 'menu') {
          path = result[0].child[0].path
        } else {
          path = result[0].child[0].child[0].path
        }
        this.$router.push({
          path: path
        })
      }else if (idx == 6) {
        let result = JSON.parse(localStorage.getItem('menuList')).filter(item => {
          return item.rule_id == 2200
        })
        let path = result[0].child[0]
        if (path.type == 'menu') {
          path = result[0].child[0].path
        } else {
          path = result[0].child[0].child[0].path
        }
        console.log(path)
        this.$router.push({
          path: path
        })
      }
    },
    // 获取权限列表
    getPermissionList() {
      this.$get(this.$api.permissionList).then(res => {
        if (res.status == 200) {
          localStorage.setItem('menuList', JSON.stringify(res.data))
          this.getRuleIds()
        }
      })
    },
    // 获取当前帐号的权限ids
    getRuleIds() {
      this.$get(this.$api.ruleIds).then(res => {
        if (res.status == 200) {
          localStorage.setItem('ruleIds', JSON.stringify(res.data))
          //清理缓存后 刷新页面
          location.reload();
        }
      })
    },
    goback() {
      this.$router.go(-1)
    },
    haveThis(id) {
      let list = JSON.parse(localStorage.getItem('menuList'))
      return list.some(item => { return item.rule_id === id })
    },
    goAdd() {
      this.$router.push({
        path: '/sourceMarket'
      });
    },
    // setNavStatus(idx) {
    //   this.$store.commit('saveNavStatus', idx)
    //   if (idx == 0) {
    //     let result = JSON.parse(localStorage.getItem('menuList')).filter(item => {
    //       return item.rule_id == 107
    //     })
    //     let path = result[0].child[0]
    //     if (path.type == 'menu') {
    //       path = result[0].child[0].path
    //     } else {
    //       path = result[0].child[0].child[0].path
    //     }
    //     this.$router.push({
    //       path: path
    //     })
    //   } else if (idx == 1) {
    //     let result = JSON.parse(localStorage.getItem('menuList')).filter(item => {
    //       return item.rule_id == 1000
    //     })
    //     let path = result[0].child[0]
    //     if (path.type == 'menu') {
    //       path = result[0].child[0].path
    //     } else {
    //       path = result[0].child[0].child[0].path
    //     }
    //     this.$router.push({
    //       path: path
    //     })
    //   } else if (idx == 4) {
    //     let result = JSON.parse(localStorage.getItem('menuList')).filter(item => {
    //       return item.rule_id == 1025
    //     })
    //     let path = result[0].child[0]
    //     if (path.type == 'menu') {
    //       path = result[0].child[0].path
    //     } else {
    //       path = result[0].child[0].child[0].path
    //     }
    //     this.$router.push({
    //       path: path
    //     })
    //   } else if (idx == 5) {
    //     let result = JSON.parse(localStorage.getItem('menuList')).filter(item => {
    //       return item.rule_id == 1500
    //     })
    //     let path = result[0].child[0]
    //     if (path.type == 'menu') {
    //       path = result[0].child[0].path
    //     } else {
    //       path = result[0].child[0].child[0].path
    //     }
    //     this.$router.push({
    //       path: path
    //     })
    //   }
    //   // else if(idx==5){
    //   //   this.$router.push({
    //   //     path: '/configuration'
    //   //   })
    //   // }
    // },
    // 分享
    shareLink() {
      // console.log('user', this.$store.state.shop_data)
      let target = document.createElement('input') //创建input节点
      target.value = this.$baseUrl + '/custom?shopid=' + this.$store.state.shop_data.shop_id // 给input的value赋值
      document.body.appendChild(target) // 向页面插入input节点
      target.select() // 选中input
      document.execCommand('Copy')
      document.body.removeChild(target);
      this.$message({
        message: '复制成功',
        type: 'success'
      })
    },
    gochooseStore() {
      this.$router.push({
        path: '/chooseStore'
      })
    },
    openFullScreen() {
      document.documentElement.requestFullscreen()
    },
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false
      })
        .then(() => {
          delCookie('user')
          delCookie('pwd')
          localStorage.setItem('logintoken_shop', '')
          localStorage.setItem('userdata_shop', '')
          localStorage.setItem('ishavaStore', '')
          this.$router.push({
            path: '/login'
          })
          this.$message({
            type: 'success',
            message: '已退出登录!'
          })
          // this.$post(this.$api.logout).then(res=>{
          //   if(res.code==0){
          //     delCookie('user')
          //     delCookie('pwd')
          //     localStorage.setItem('logintoken_shop', '')
          //     localStorage.setItem('userdata_shop', '')
          //     this.$router.push({ path: '/login' })
          //     this.$message({
          //       type: 'success',
          //       message: '已退出登录!'
          //     })
          //   }else{
          //     this.$message.error(res.message)
          //     return false
          //   }
          // })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    },
    goupdatePwd() {
      this.$router.push({
        path: '/updatePwd'
      })
    },
    gouserCenter() {
      this.$router.push({
        path: '/userCenter'
      })
    },
    goMessage() {
      this.drawerVisible = true;
      this.getMessage();
    },
    getMessage() {
      this.$get(this.$api.message_list).then(res => {
        if (res.status == 200) {
          this.messageList = res.data.list;
          const unreadCount = this.messageList.filter(msg => msg.is_read == 0).length;
          this.setMessageCount(unreadCount);
          localStorage.setItem('shop_message_count', String(unreadCount));
        }
      })
    },
    markAllAsRead() {
      var ids = this.messageList.map(msg => msg.shop_ad_id);
      this.$post(this.$api.message_is_read, { shop_ad_ids: ids }).then(res => {
        if (res.status == 200) {
          this.getMessage();
          this.$message.success('全部已读');
        }
      })
    },
    deleteAllMessages() {
      var ids = this.messageList.map(msg => msg.shop_ad_id);
      this.$delete(this.$api.message_delete, { shop_ad_ids: ids }).then(res => {
        if (res.status == 200) {
          this.messageList = [];
          this.setMessageCount(0);
          localStorage.setItem('shop_message_count', '0');
          this.$message.success('全部消息已删除');
        }
      })
    },
    showMessageDetail(msg) {
      this.currentMessage = msg;
      this.dialogVisible = true;
      this.$post(this.$api.message_is_read, { shop_ad_ids: [this.currentMessage.shop_ad_id] }).then(res => {
        if (res.status == 200) {
          this.getMessage();
        }
      })
    },
    handleExportExcel() {
      if (this.currentMessage && this.currentMessage.data == 1) {
        let data = this.currentMessage.data;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
            this.exportToExcel(data);
          } catch (e) {
            this.$message.error('数据格式错误，无法导出');
            return;
          }
        }
      } else if (this.currentMessage && this.currentMessage.data == 2) {
        this.openUrl('https://byds.xxyzx.com.cn' + this.currentMessage.data);
      } else {
        this.$message.error('无可导出的数据');
      }
    },
    exportToExcel(data) {
      // 创建一个新的工作簿
      const workbook = XLSX.utils.book_new();
      // 将 JSON 数据转换为工作表，确保数据的顺序和内容不变
      const worksheet = XLSX.utils.json_to_sheet(data, { skipHeader: true });
      // 将工作表添加到工作簿中，并命名为“数据”
      XLSX.utils.book_append_sheet(workbook, worksheet, '数据');
      // 将工作簿写入文件
      XLSX.writeFile(workbook, '数据.xlsx');
    },
    deleteSingleMessage(msg) {
      this.$delete(this.$api.message_delete, { shop_ad_ids: [msg.shop_ad_id] }).then(res => {
        if (res.status == 200) {
          this.getMessage();
          this.$message.success('删除成功');
        }
      })
    },
    openUrl(url) {
      try {
        new URL(url);
        window.open(url, '_blank');
      } catch (e) {
        this.$message.error('链接格式不正确，无法打开');
      }
    }
  }
}
</script>
<style scoped>
.title {
  font-size: 14px;
  color: white;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin: 0 20px;
}

.title div {
  cursor: pointer;
}

.title div:hover {
  color: #409EFF;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}

.submenu {
  float: right;
}

.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
  color: white;
}

.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}

.showimg:active {
  border: none;
}

.iclass {
  font-size: 20px;
  cursor: pointer;
  margin-left: 16px;
  transition: all .2s;
  color: white;
}

.iclass:hover {
  font-size: 26px;
}

.newbtn {
  flex: 1;
  color: white;
  font-size: 14px;
  display: flex;
  align-items: center;
  font-weight: bold;
}

.newbtn p {
  margin: 0 10px;
  font-weight: normal;
}

.newbtn span {
  margin: 0 10px;
  cursor: pointer;
}

.newbtn span:hover {
  color: #409EFF;
}

.newbtn .span {
  color: #409EFF;
}

.message-list {
  display: flex;
  flex-direction: column;
  padding: 5px 10px;
}

.message-list-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 200px);
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue